import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { client } from "@/hono";

/** The query key of the Personio sync table, for the invalidation after a sync. */
export const PERSONIO_SYNC_QUERY_KEY = ["personio", "sync"];

export function usePersonioSync() {
	/** Query */
	const query = useQuery({
		queryKey: PERSONIO_SYNC_QUERY_KEY,
		queryFn: async () => {
			const response = await client.integrations.personio["auto-integration"].$get();
			return await responseHandler(response);
		},
	});

	/** Return */
	return {
		...query,
		people: query.data?.people,
		createBlocker: query.data?.createBlocker ?? null,
	};
}
